import React from 'react';
import Aboutpage from '../Aboutpage/Aboutpage';
import Abouttext from '../Abouttext/Abouttext';

const About = () => {
    return (
        <>
           <Aboutpage />
           <Abouttext /> 
        </>
    );
};

export default About;